import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart, ChartType, ChartOptions, ChartDataset } from 'chart.js';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AddQueueDialogComponent } from 'src/app/core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { DateFilterComponent } from 'src/app/core/dialogs/date-filter/date-filter.component';
import { GridSingleviewLinkHomeGridComponent } from 'src/app/core/grid/grid-singleviewlink-homegrid.component';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { ContingencyPCSService } from 'src/app/service/pcs/contingency-pcs.service';
import { PeriodsService } from 'src/app/service/periods.service';
import { GroupIHomeService } from '../../service/groupi-home.service';
Chart.register(ChartDataLabels);

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
	standalone: false
})

export class HomeComponent implements OnInit {

	gridApi: any;
	gridColumnApi: any
	defaultColDef = {};
	setPagination = true;
	paginationPageSize = 10;
	currentPageNo: any;
	currentPageBoolean: boolean = false;
	totalPage: any;
	currentPageForTotalPage: any;
	isLastPageFound: any;
	isAccessible = false;
	@ViewChild('agGrid', { static: true }) agGrid

	rowCount;
	errorMessage: string;
	successMessage: string;
	context: any;

	selected_period_id
	selected_period_value

	modules;
	gridOptions;

	frameworkComponents;
	rowData;
	columnDefs;
	icons;
	getRowStyle;

	openCard = true;
	totalComplete;
	LLTComplete;

	tile_one_TC;
	tile_two_LLTC;
	tile_three_CC;

	piechartcolorList = [];
	domicileList = [];

	GroupI_WidgetsData = {
		id_TierPosition: null,
		id_Round: null,
		id_KPI: null,
		id_Alarm: null,
		alarm_type_id: null,
		title_Tier: null,
		title_Route: null,
		isCompleted: 0,
		isVerified: 0,
		isRoutes: 0

	}


	//pie chart
	public pieChartOptions: ChartOptions<'pie'> = {
		responsive: true,
		maintainAspectRatio: false,
		hover: {
			mode: null
		},
		plugins: {
			legend: {
				position: 'top',
				maxHeight: 100,
				labels: {
					 boxWidth: 25,     // reduces the colored square size
					padding: 9,       // space between legend items and chart
					font: {
						size: 12       // optional: to reduce overall size
					}
				},

			},
			datalabels: {
				display: false
			},
			tooltip: {
				enabled: true // keep tooltip
			}
		},
		elements: {
			arc: {
				hoverOffset: 0
			}
		},

		radius: '80%' 

	};





	public pieChartData: ChartDataset<'pie'>[] = [];
	public pieChartLabels: string[] = [];
	public pieChartPlugins = [ChartDataLabels];
	public pieChartType: ChartType = 'pie';
	public pieChartLegend = true;
	//   public pieChartPlugins = [pluginDataLabels];
	public pieChartColors;

	public nodataOptions: ChartOptions<'pie'> = {
		responsive: true,
		maintainAspectRatio: false,
		hover: {
			mode: null
		},
		plugins: {
			legend: {
				position: 'top',
				maxHeight: 100,
				labels: {
					 boxWidth: 25,     // reduces the colored square size
					padding: 9,       // space between legend items and chart
					font: {
						size: 12       // optional: to reduce overall size
					}
				},

			},
			datalabels: {
				display: false
			},
			tooltip: {
				enabled: true // keep tooltip
			}
		},
		elements: {
			arc: {
				hoverOffset: 0
			}
		},

		radius: '80%' 

	};


	public nodata: number[] = [100];
	nodatacolor = [{
		backgroundColor: ['#e5e5e5']
	}];
	nodataLabels = ["No Data"];
	isPieChartData = false;

	// bar chart
	public barChartOptions: ChartOptions<'bar'> = {
		responsive: true,
		maintainAspectRatio: false,
		scales: {
			y: {
				beginAtZero: true
			}
		},
		plugins: {
			legend: {
				display: false
			},
			datalabels: {
				display: false
			},
		}
	};



	public barChartData: ChartDataset<'bar'>[] = [];
	public barChartLabels: string[] = [];
	public barChartPlugins = [ChartDataLabels];
	public barChartType: ChartType = 'bar';
	public barChartLegend = true;
	//   public barChartPlugins = [pluginDataLabels];

	// public barChartData: ChartDataSets[] = [{
	// 	barPercentage: 0.2
	// }];

	// public barChartData: ChartDataset<'bar'>[] = [
	// 	{
	// 		data: [],
	// 		backgroundColor: ["#FEB843", "#4632fc"],
	// 		borderRadius: 5
	// 	}
	// ];


	public chartColors: any[] = [
		{
			backgroundColor: ["#FEB843", "#4632fc"]
		}];
	barPlannedCount: any;
	barCompleteCount: any;
	tilesValueLoading: boolean = false;
	barChartLoading: boolean = false;
	pieChartLoading: boolean = false;
	homeTiersDataLoading: boolean = false;
	overlayLoadingTemplate = `<div class="spinner-grow text-secondary" role="status"></div>`


	sizeToFit() { this.gridApi.sizeColumnsToFit(); }
	goToNexpage() { this.gridApi.paginationGoToNextPage(); }
	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage()  }
	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }
	goToLastPage() { this.gridApi.paginationGoToLastPage()  }
	onPageSizeChanged(event: any) {
		if (event.target.value == "ALL")  // NOSONAR
		{
			this.gridApi?.setGridOption('paginationPageSize', Number(this.rowData.length));
		}
		else
		{
			this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		}
	}

	getCurrentPage(): boolean {
		this.currentPageNo = this.agGrid.api ? this.agGrid.api.paginationGetCurrentPage() : 0;
		if (this.currentPageNo == 0) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.totalPage = Number(this.agGrid.api ? this.agGrid.api.paginationGetCurrentPage() : 0);
		this.currentPageForTotalPage = Number(this.agGrid.api ? this.agGrid.api.paginationGetCurrentPage() : 0) + 1;
		if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}
	onGridReady(param: any) {
		this.gridApi = param.api;
		this.gridColumnApi = param.columnapi;

	}

	onGridSizeChanged(params: any) {
		params.api.sizeColumnsToFit();
	}
	$timeout() {
		this.gridApi.core.handleWindowResize();

	};



	// randomNum() { return Math.floor(Math.random() * (235 - 52 + 1) + 52); }
	randomRGB() {
		const color = "hsl(" + Math.random() * 360 + ", 100%, 65%)";
		return color;
	}

	constructor(public dialog: MatDialog, public readonly groupiService: GroupIHomeService, private readonly ngxUiLoaderService : NgxUiLoaderService, private readonly groupIStateService : GroupIStateService,
		private readonly constants: Constants, private readonly periodsService : PeriodsService, private readonly contingencyPCSService : ContingencyPCSService, private readonly router: Router) {

		this.pieChartOptions.plugins.legend.position = 'right';
		this.nodataOptions.plugins.legend.position = 'right';
		this.gridOptions = {
			theme: 'legacy'
		  }
		this.context = {
			componentParent: this
		};

		// bar chart

		this.barChartLabels = [];
		this.frameworkComponents = {
			// btnCellRenderer: BtnCellRenderer
		};
		this.defaultColDef = {
			suppressMovable: true,
			suppressHeaderFilterButton: true ,suppressCellSelection: true
		}
		this.columnDefs = [
			{
				headerName: "Recent Tiers", headerClass: "table_title", field: "description",
				cellClass: "cell_title", width: 120,
				autoHeight: true,
				cellRenderer: GridSingleviewLinkHomeGridComponent,

			},
			{
				headerName: "#Issues", headerClass: "table_issues", field: "issueCount",
				cellClass: "cell_issues", width: 120,
				sortable: true, unSortIcon: true, autoHeight: true
			},
			{
				headerName: "#Evaluation", headerClass: "table_completed", field: "completed",
				cellClass: "cell_completed", width: 120,
				sortable: true, unSortIcon: true, autoHeight: true
			},
			{
				headerName: "#Open", headerClass: "table_open", field: "open",
				cellClass: "cell_open", width: 120,
				sortable: true, unSortIcon: true, autoHeight: true
			},
			{
				headerName: "%Evaluation", headerClass: "table_completed", field: "completedPercent",
				cellClass: "cell_completed", width: 120,
				sortable: true, unSortIcon: true, autoHeight: true
			},
			{
				headerName: "Round Status", headerClass: "table_round_status", field: "roundStatus",
				cellClass: "cell_round_status", width: 120,
				sortable: true, unSortIcon: true, autoHeight: true
			}
		];
	}

	ngOnInit(): void {
		this.icons = {
			sortUnSort: '<img src="./assets/images/unsort.svg">',
		};
		// this.checkRoles();
	}

	async checkRoles() {
		this.ngxUiLoaderService.start(this.constants.LoaderInitializer)
		await this.groupIStateService.getRoles();
		this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);

		const roles = this.groupIStateService.getroleState();
		const userRoles = JSON.parse(roles);
		// if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
		// 	if (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin))
		// 		this.isAccessible = true;
		// } else {
		// 	window.location.replace(this.constants.LIOSMainPortalURL);
		// }
	}

	componentEventHandler(event) {
		if (event.eventType == "NOTIFICATION_ERROR") {  // NOSONAR
			this.errorMessage = event.eventMessage;
			setTimeout(() => {
				this.successMessage = "";
				this.errorMessage = "";
			}, this.constants.notificationMessageTime);
		} else if (event.eventType == "CHANGE_PERIOD") {  // NOSONAR
			this.selected_period_id = event.periodId
			this.selected_period_value = event.periodValue
			this.loadData();
		}
	}


	onDateClick() {
		//open date component
		const dialogRef = this.dialog.open(DateFilterComponent, {
			disableClose: true,
			width: '250px',
			height: '171px',
			position: {
				top: '19%',
				left: '6%'
			},
			data: {
				data: "data"
			}

		});

		dialogRef.afterClosed().subscribe(_result => {


		});
	}

	closeCardClick() {
		this.openCard = false;
	}

	openCardClick() {
		this.openCard = true;
	}

	getTilesValue(period_id: any) {
		this.tilesValueLoading = true;
		this.groupiService.getTilesValue(period_id).subscribe(
			data => {
				if (data) {
					this.tile_one_TC = data.totalCompletePercent ? data.totalCompletePercent : 0;
					this.tile_one_TC = this.tile_one_TC.toFixed(2)
					this.tile_two_LLTC = data.lltCompletePercent ? data.lltCompletePercent : 0;
					this.tile_two_LLTC = this.tile_two_LLTC.toFixed(2)
					this.tile_three_CC = data.contingencyCompletePercent ? data.contingencyCompletePercent : 0;
					this.tile_three_CC = this.tile_three_CC.toFixed(2)
				}
				this.tilesValueLoading = false;
			}, error => {
				console.info(error)
				this.tilesValueLoading = false;
			});
	}

	// getBarChartValue(period_id: any) {
	// 	this.barChartLoading = true;
	// 	this.groupiService.getbarChartValue(period_id).subscribe(data => {
	// 		if (data) {
	// 			this.totalComplete = data.plannedTotalPercentage ? data.plannedTotalPercentage : 0;
	// 			this.LLTComplete = data.completeTotalPercentage ? data.completeTotalPercentage : 0;
	// 			this.barPlannedCount = data.totalIssues ? data.totalIssues : 0;
	// 			this.barCompleteCount = data.completeCount ? data.completeCount : 0;
	// 			// bar chart
	// 			this.barChartLabels = [this.barPlannedCount, this.barCompleteCount];
	// 			this.barChartData =
	// 				[{
	// 					data: [this.barPlannedCount, this.barCompleteCount],
	// 					label: `${this.barPlannedCount},${this.barCompleteCount}`,
	// 					barPercentage: 0.2,
	// 					borderRadius: 5
	// 				}];
	// 		}
	// 		this.barChartLoading = false;
	// 	}, error => {
	// 		this.barChartLoading = false;
	// 	});
	// }

	getBarChartValue(period_id: any) {
		this.barChartLoading = true;
		this.groupiService.getbarChartValue(period_id).subscribe(data => {
			if (data) {
				this.totalComplete = data.plannedTotalPercentage ?? 0;
				this.LLTComplete = data.completeTotalPercentage ?? 0;
				this.barPlannedCount = data.totalIssues ?? 0;
				this.barCompleteCount = data.completeCount ?? 0;

				this.barChartLabels = [this.barPlannedCount, this.barCompleteCount];
				this.barChartData = [
					{
						data: [this.barPlannedCount, this.barCompleteCount],
						label: `${this.barPlannedCount},${this.barCompleteCount}`,
						barPercentage: 0.2,
						backgroundColor: ["#FEB843", "#4632fc"]
					}
				];
			}
			this.barChartLoading = false;
		}, error => {
			console.info(error)
			this.barChartLoading = false;
		});
	}


	getHomePieChartDate(period_id: any) {
		this.pieChartLoading = true;
		this.groupiService.getHomePieChartData(period_id).subscribe(data => {
			this.pieChartData = [];
			this.pieChartLabels = [];
			if (data && data.length > 0) {
				const pieData = [];
				const labels = [];
				const colors  = [];
				data.forEach(x => {
					labels.push(x.domicile);
					pieData.push(x.percentage);
					colors.push(this.randomRGB());

				})
				console.info(colors)
				this.pieChartLabels = labels;
				this.pieChartData = [{
					data: pieData
				}];
				this.isPieChartData = true;
				this.pieChartLoading = false;
			} else
				{this.isPieChartData = false;}
			this.pieChartLoading = false;
		}, error => {
			console.info(error)
			this.pieChartLoading = false;
		});
	}

	getHomeTiersData(period_id: any) {
		this.homeTiersDataLoading = true;
		this.gridApi?.showLoadingOverlay();
		this.groupiService.getHomeTiersData(period_id).subscribe(data => {
			this.rowData = [];
			this.rowCount = 0;
			const gridData = [];
			if (data) {
				for (const [_key, value] of Object.entries(data)) {
					const x: any = value;
					const row = {
						"description": x.description,
						"issueCount": Number(x.totalIssue ? x.totalIssue : 0),
						"completed": Number(x.totalComplete ? x.totalComplete : 0),
						"open": Number(x.issueOpen ? x.issueOpen : 0),
						"completedPercent": Number(x.completePercentage),
						"roundStatus": x.roundStatus,
						"tierPosition": x.tierPosition,
						"round": x.round,
						"logic": x.logic
					}
					gridData.push(row);
				}

				this.rowData = gridData;
				this.gridApi?.setGridOption('rowData', this.rowData);
				this.rowCount = this.rowData.length;
			}
			this.homeTiersDataLoading = false;
			this.gridApi?.hideOverlay();
		}, error => {
			console.info(error)
			this.rowData = [];
			this.rowCount = 0;
			this.homeTiersDataLoading = false;
			this.gridApi?.hideOverlay();
		});

	}

	loadData() {
		if (this.selected_period_id) {
			this.getTilesValue(this.selected_period_id)
			this.getBarChartValue(this.selected_period_id);
			this.getHomePieChartDate(this.selected_period_id);
			this.getHomeTiersData(this.selected_period_id)
		} else {
			this.rowData = [];
			this.rowCount = 0;
			this.gridApi?.setGridOption('rowData', this.rowData);
		}
	}

	redirectToDetailPage(data) {

		this.GroupI_WidgetsData.id_TierPosition = data.tierPosition;
		this.GroupI_WidgetsData.id_Round = data.round;
		localStorage.setItem('GroupI_WidgetsData', JSON.stringify(this.GroupI_WidgetsData));

		this.router.navigate(['tier-level']);
	}

	AddToQueue(): void {

		const dialogRef = this.dialog.open(AddQueueDialogComponent, {
			disableClose: true,
			width: '500px',
			height: '240px',
			data: { header: 'Add To Queue' }
		});

		dialogRef.afterClosed().subscribe(result => {
			this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
			if (result.event == 'SaveEvent') {  // NOSONAR
				if (result.data == "Success") {   // NOSONAR
					this.successMessage = this.constants.APIAddToQueueSuccess;
					setTimeout(() => {
						this.successMessage = "";
						this.errorMessage = "";
					}, this.constants.notificationMessageTime);
				}

			}
		});
	}

}
